document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('emailSignupPopup');
  const closeButton = document.getElementById('closeEmailPopup');
  const emailForm = document.getElementById('emailSignupForm');
  const emailInput = document.getElementById('popupEmailInput');
  const thankYouMessage = document.getElementById('popupThankYouMessage');
  const popupTrigger = document.getElementById('emailPopupTrigger'); // New trigger element

  // Function to show the panel
  const showPanel = () => {
    if (popup) {
      popup.style.display = 'flex'; // Or 'block', depending on new CSS
      // Potentially add a class for 'open' state for CSS transitions
      popup.classList.add('is-open'); 
    }
  };

  // Function to hide the panel
  const hidePanel = () => {
    if (popup) {
      // popup.style.display = 'none';
      // Potentially remove a class for 'open' state for CSS transitions
      popup.classList.remove('is-open');
      // Reset form if it was submitted
      if (emailForm && thankYouMessage && thankYouMessage.style.display === 'block'){
        emailForm.style.display = 'block';
        thankYouMessage.style.display = 'none';
        if(emailInput) emailInput.value = ''; // Clear email input
      }
    }
  };

  // Event listener for the new trigger
  if (popupTrigger) {
    popupTrigger.addEventListener('click', () => {
      if (popup.classList.contains('is-open')) {
        hidePanel();
      } else {
        showPanel();
      }
    });
  }

  const DISMISS_KEY = 'mirrykoru_popup_dismissed_until';
  const DISMISS_DAYS = 7;

  const dismissForNow = () => {
    const until = Date.now() + DISMISS_DAYS * 24 * 60 * 60 * 1000;
    try {
      localStorage.setItem(DISMISS_KEY, String(until));
    } catch (e) {}
  };

  const isDismissed = () => {
    try {
      const until = parseInt(localStorage.getItem(DISMISS_KEY), 10);
      return until && Date.now() < until;
    } catch (e) {
      return false;
    }
  };

  // Event listener for the close button inside the panel
  if (closeButton) {
    closeButton.addEventListener('click', () => {
      hidePanel();
      dismissForNow();
    });
  }

  // Email form submits natively (Shopify's customer form rejects AJAX/JSON
  // submissions without a CAPTCHA token). `return_to=back` brings the visitor
  // back here with ?customer_posted=true, which we detect below to show the
  // thank-you state without leaving the page conceptually.
  if (emailForm) {
    emailForm.addEventListener('submit', () => {
      dismissForNow();
    });
  }

  const justSubscribed = new URLSearchParams(window.location.search).get('customer_posted') === 'true';

  if (justSubscribed) {
    if (emailForm) emailForm.style.display = 'none';
    if (thankYouMessage) thankYouMessage.style.display = 'block';
    showPanel();
    dismissForNow();
    // Clean the query param so reloading/sharing the URL doesn't re-show it.
    const cleanUrl = window.location.pathname + window.location.hash;
    window.history.replaceState({}, document.title, cleanUrl);
  }

  // Auto-show on entry: only on homepage/collection pages, with an empty cart,
  // and only if not already dismissed/subscribed recently.
  const context = window.popupContext || {};
  const eligiblePageTypes = ['index', 'list-collections', 'collection'];
  const shouldAutoShow =
    popup &&
    !justSubscribed &&
    !isDismissed() &&
    context.cartItemCount === 0 &&
    eligiblePageTypes.indexOf(context.pageType) !== -1;

  if (shouldAutoShow) {
    setTimeout(showPanel, 3000);
  }

  // Optional: Close panel if user clicks outside the content (if it's still a modal-like overlay for the panel)
  // This might need adjustment based on the new side-panel styling.
  // If the main popup container still has a backdrop, this can work.
  if (popup) {
    popup.addEventListener('click', (event) => {
      if (event.target === popup && popup.classList.contains('is-open')) { // Check if the click is on the backdrop
        hidePanel();
      }
    });
  }
});
